var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
function SvgCloseCircled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    "data-name": "Header - Opt 1 (Grey)",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement(G, {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement(Path, {
    className: "closeCircled_svg__st0",
    d: "M8.25 8.967l.707-.707 17.678 17.677-.708.708z",
    strokeWidth: 0.199998
  }), /*#__PURE__*/React.createElement(Path, {
    className: "closeCircled_svg__st0",
    d: "M8.664 26.28l-.708-.707L25.634 7.896l.707.707z",
    strokeWidth: 0.199998
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M17.5.88c9.17 0 16.62 7.46 16.62 16.62S26.66 34.12 17.5 34.12.88 26.67.88 17.5 8.33.88 17.5.88m0-.88C7.88 0 0 7.88 0 17.5S7.88 35 17.5 35 35 27.12 35 17.5 27.12 0 17.5 0h0z",
    fill: "#e1087e",
    stroke: "#e1087e",
    strokeWidth: 0.3
  }))));
}
export default SvgCloseCircled;